import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";

const StateInput = props => {
  const {
    text,
    field: { touched, error, ...field },
  } = props;

  delete field.initialValue;
  delete field.autofill;
  delete field.onUpdate;
  delete field.valid;
  delete field.invalid;
  delete field.dirty;
  delete field.pristine;
  delete field.active;
  delete field.visited;
  delete field.autofilled;

  const states = [];
  text.states.forEach(state => {
    states.push(
      <option key={state} value={state}>
        {state}
      </option>
    );
  });
  const formControlClass = classnames("form-control", {
    placeholder: !field.value,
  });
  const formGroupClass = classnames("form-group", {
    "has-error": touched && error,
  });
  return (
    <div className={formGroupClass}>
      <select {...field} value={field.value || ""} className={formControlClass}>
        <option value="" disabled="disabled">
          {text.state}
        </option>
        {states}
      </select>
      {touched && error && <div className="help-block">{error}</div>}
    </div>
  );
};

StateInput.propTypes = {
  field: PropTypes.object.isRequired,
  text: PropTypes.object.isRequired,
};

export default StateInput;



// WEBPACK FOOTER //
// ./src/components/StateInput.js